import * as THREE from 'three'
import { MathUtils } from 'three'
import { useRef } from 'react'
import { Canvas, useFrame } from '@react-three/fiber'
import { OrbitControls, Edges, Center, Bounds, Instances, Instance } from '@react-three/drei'
import { Physics, RigidBody, CuboidCollider, BallCollider, CylinderCollider } from '@react-three/rapier'
import * as Tone from 'tone'
let randI = (i) => Math.floor(i * fxrand())
let rand = (arr) => arr[randI(arr.length)]

const feats = window.$fxhashFeatures = {
  bpm: rand([5,7,8]),
  speed: rand([0.04,0.01,0.005,0.004,0.003,0.002]),
  light: rand([true,false]),
  pads: rand([true, false]),
  hats: rand([true, false]),
  rings: 1 + randI(3),
  boost: 1+randI(4)
}
console.table(feats)
let col = feats.light ? 'black' : 'white'
let bg = feats.light ? 'white' : 'black'
let loopAmt = 5
let spawn = Array(loopAmt).fill(true)
let counts = Array(loopAmt).fill(0)
let started = true
Tone.Transport.bpm.value = feats.bpm
let loopNotes = new Array(loopAmt).fill().map((_, i) => rand(['C2', 'D2', 'E2', 'A2']))

let loops = new Array(loopAmt).fill().map((_, i) =>
  new Tone.Loop(() => {
    spawn[i] = true
    counts[i] = (counts[i] + 1) % count
    if (loopCount % 8 === 0) {
    }
    l = feats.boost
    samplers[i].triggerAttackRelease([loopNotes[i], padScale + '2'], 4, '+0.0001', rand([0.1, 0.15]) * 0.2)
  }, rand(['1m', '2n', '4t', '2t', '2m', '2n', '8t', '8n']))
)

let padScales = ['C', 'D', 'E']
let padScale = rand(padScales)
let padLoop = new Tone.Loop(() => {
  linCounter++;
  if ((!(linCounter % 4))) {
    padScale = rand(padScales)
  }
  rand(padSamplers).triggerAttackRelease(padScale + '2', '1m', '+0.0001', rand([0.14, 0.13, 0.15]) * 0.2)
}, '8n')
let hatCount = 0
let slamMod = rand([8,16,32])
let hatLoop = new Tone.Loop(() => {
  hatCount++;
  if (hatCount % slamMod) {
    rand(hatSamplers).triggerAttackRelease([padScale + '2'], '1m', '+0.0001', rand([0.14, 0.13, 0.15, 0.18]) * 0.04)
    rand(hatSamplers).triggerAttackRelease([padScale + '2'], '1m', '+0.0001', rand([0.14, 0.13, 0.15, 0.18]) * 0.04)
  } else {
    rand(hatSamplers).triggerAttackRelease([padScale + '1'], '2m', '+0.0001', rand([0.14, 0.13, 0.15, 0.18]) * 0.04)
    rand(hatSamplers).triggerAttackRelease([padScale + '1'], '2m', '+0.0001', rand([0.14, 0.13, 0.15, 0.18]) * 0.04)
    rand(hatSamplers).triggerAttackRelease([padScale + '1'], '2m', '+0.0001', rand([0.14, 0.13, 0.15, 0.18]) * 0.04)
    rand(hatSamplers).triggerAttackRelease([padScale + '2'], '2m', '+0.0001', rand([0.14, 0.13, 0.15, 0.18]) * 0.04)
    l = 10
  }
}, Tone.Time('8n').toSeconds()*0.5)
let moved = false

export default function App() {
  let up = () => {
    if (moved && started) {
      return
    }
    Tone.start();
    Tone.Transport.start();
    loops.forEach((l, li) => {
      l.stop()
      l.start('+' + Tone.Time('64n').toSeconds() * 0.5 * li)
    })
    if(feats.pads){
    padLoop.stop()
    padLoop.start()
  }
    if(feats.hats){
      hatLoop.stop()
      hatLoop.start()
    }
    shuffle(samplers)
    shuffle(padSamplers)
    started = true
    shuffle(bodyPositions)
    l = 5
  }
  let down = () => {
    moved = false
  }
  return (
    <div id="main" onMouseDown={down} onMouseMove={() => { moved = true }} onMouseUp={up}>
      <Canvas orthographic camera={{ position: [0, 0, 100], zoom: 120, near: 0.01 }}>
        <World />
        <color attach="background" args={[bg]} />
        <OrbitControls/>
      </Canvas>
    </div>
  )
}

function shuffle(array) {
  let currentIndex = array.length, randomIndex;
  while (currentIndex != 0) {
    randomIndex = Math.floor(fxrand() * currentIndex);
    currentIndex--;
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }
  return array;
}

let samples = [
  "./quasi/Synth/Synth-DigiDroplet2.wav",
]

let lerp = THREE.MathUtils.lerp
let count = 1;
let loopCount = 0
let amt = feats.rings
let s = 2
let notes = new Array(amt).fill().map(() => rand(['C', 'D', 'E']) + rand([5, 6]))
let rots = new Array(amt).fill().map(() => rand([0, 0]) * Math.PI)
let rots2 = new Array(amt).fill().map(() => (randI(8) * 0.25) * Math.PI)
const samplers = new Array(Math.max(loopAmt,amt)).fill().map((v, i) => {
  let sampler = new Tone.Sampler({
    urls: {
      [rand(['C2', 'C3'])]: rand(samples),
    },
  }).connect(new Tone.Panner((-10 + randI(20)) * 0.1).toDestination())
  sampler.attack = 1
  sampler.release = 1
  return sampler
})
let padSamples = [
  "./RolandJD800/PAD-90sAmbientPad.wav",
  "./RolandJD800/PAD-90sAmbientPad2.wav",
]
let padSamplers = new Array(loopAmt).fill().map(() => {
  let pad = new Tone.Sampler({
  urls: {
    C2: rand(padSamples),
  },
}).connect(new Tone.Panner((-10 + randI(20)) * 0.1).toDestination())
pad.connect(new Tone.PitchShift(7).connect(new Tone.Chorus(1,0.25,1).connect(new Tone.PingPongDelay().toDestination())))
return pad
})
padSamplers.attack = 2
padSamplers.release = 4
let hatSamples = [
  "./drums/HIHATS/Legowelt Hat2open.wav",
]
let hatSamplers = new Array(loopAmt).fill().map(() => new Tone.Sampler({
  urls: {
    C3: rand(hatSamples),
  },
}).connect(new Tone.Panner((-10 + randI(20)) * 0.1).toDestination()))

let linVels = []
let randLinVels = () => new Array(loopAmt).fill().map(() => [
  MathUtils.randFloatSpread(10) * 0.5,
  MathUtils.randFloatSpread(5) * 0.5,
  0
])
linVels[0] = randLinVels()
linVels[1] = randLinVels()
let linCounter = 0
function detectMob() { return ( ( window.innerWidth <= 1000 ) && ( window.innerHeight <= 1000 ) )}
function World() {
  useFrame(() => {
    l = lerp(l,1,0.04)
  })
  return (
    <group>
      <Physics gravity={[randI(20) * rand([1, -1]) * 0, -randI(50) * 0.02 * -0, 0]}>
        <Bounds fit margin={detectMob() ? 1.8 : 3.4} damping={0}>
        <Center>
          {notes.map((n, i) =>
            <Obstacles i={i} n={n} key={i} />
          )}
          <group rotation={[0, Math.PI, 0]}>
            {notes.map((n, i) =>
              <Obstacles i={i} n={n} key={i} />
            )}
          </group>
        </Center>
        </Bounds>
        {loops.map((_, j) =>
          <Bouncers i={j} y={-2 + (j)} key={j} />
        )}
      </Physics>
    </group>
  )
}

let bodyPositions = new Array(loopAmt).fill().map(() => new Array())
let trailAmt = 170
let bounceScale = rand([0.1, 0.2,0.3,0.4,0.5])*0.3
let lastPos = new Array(loopAmt).fill().map(() => new THREE.Vector2())
let vec = new THREE.Vector2()
function Bouncers({ i, y }) {
  let mult = 1 + randI(3)
  const ref = useRef()
  const count = useRef(0)
  const instMat = useRef()
  useFrame(() => {
    if (spawn[i]) {
      ref.current.setTranslation({ x: 0, y: y, z: 0 })
      ref.current.setLinvel({ x: linVels[linCounter % 2][i][0], y: linVels[linCounter % 2][i][1], z: 0 })
      instMat.current.opacity = 1
    }
    if (!started) {
      ref.current.setTranslation({ x: 0, y: y, z: 0 })
      ref.current.setLinvel({ x: 0, y: 0, z: 0 })
      instMat.current.opacity = 0
    }
    vec.set(
      ref.current.translation().x,
      ref.current.translation().y
    )
    if (vec.distanceTo(lastPos[i]) > 0.1) {
      lastPos[i].copy(vec)
      bodyPositions[i].unshift([
        ref.current.translation().x,
        ref.current.translation().y,
        ref.current.translation().z,
      ])
    }

    spawn[i] = false
    bodyPositions[i].splice(trailAmt, 1)
    count.current++;
  })
  return (
    <>
      <RigidBody
        ref={ref}
      >
        <BallCollider friction={0.1} restitution={0.8} args={[(s * 0.2 * bounceScale) * (mult * 0.2)]} />
        <mesh position={[0, 0, 0]} geometry={new THREE.OctahedronBufferGeometry(s * 0.01, 2)}>
          <meshBasicMaterial color={col} transparent opacity={0} />
        </mesh>
      </RigidBody>
      <Instances limit={100000} position={[0, y, 0]} geometry={new THREE.OctahedronBufferGeometry(s * 0.005, 2)}>
        <meshBasicMaterial color={col} transparent opacity={0} ref={instMat} />
        <group position={[0, -y - ((bounceScale) * mult * 0.33), 0]}>
          {new Array(mult).fill().map((v, k) =>
            <group position={[0, k * bounceScale, 0]} key={k}>
              {new Array(trailAmt).fill().map((_, j) =>
                <BodyInstance i={i} j={j} key={j} />
              )}
              <group rotation={[0, Math.PI, 0]}>
                {new Array(trailAmt).fill().map((_, j) =>
                  <BodyInstance i={i} j={j} key={j} />
                )}
              </group>
            </group>
          )}
        </group>
      </Instances>
    </>
  )
}
let l = 10;
function BodyInstance({ i, j }) {
  const ref = useRef();
  useFrame(() => {
    if (bodyPositions[i][j]) {
      ref.current.position.set(
        lerp(ref.current.position.x, bodyPositions[i][j][0],feats.speed*l),
        lerp(ref.current.position.y, bodyPositions[i][j][1],feats.speed*l),
        lerp(ref.current.position.z, bodyPositions[i][j][2],feats.speed*l)
      )
    }
  })
  return (
    <Instance ref={ref} />
  )
}

let obstacleSides = notes.map(() => rand([128]))
let obstacleScales = notes.map(() => 0.05 + (0.05 * randI(15)))
let obstaclesRad = notes.map(() => (1 + randI(8)) * 0.1)
let obstacleNotes = notes.map((_, i) => rand(['C2', 'D2', 'E2', 'A2']))

let obstaclesSwing = 1
function Obstacles({ i, n }) {
  let sides = obstacleSides[i]
  let s = obstacleScales[i]
  return (
    <group
      position={[
        (Math.sin(Math.PI * obstaclesSwing * ((i + 1) / amt)) * obstaclesRad[i]) + (1),
        (Math.cos(Math.PI * obstaclesSwing * ((i + 1) / amt)) * obstaclesRad[i]),
        0]}
      rotation={[Math.PI * 0.5, Math.PI * 2 * rots2[i], rots[i]]}
    >
      <RigidBody
        type="fixed"
        colliders={false}
        onCollisionEnter={() => {
          rots[i] += Math.PI * 0.5
          rand(padSamplers).triggerAttackRelease([obstacleNotes[i][0] + '2', padScale+'2'], '4n', '+0.0001', rand([0.14, 0.13, 0.15]) * 0.02)
          samplers[i].triggerAttackRelease([obstacleNotes[i][0] + '2', padScale+'2'], '1m', '+0.0001', rand([0.05, 0.1, 0.15]) * 0.5)
        }}
      >
        {sides === 4 ?
          <CuboidCollider rotation={[0, Math.PI * 0.25, 0]} friction={0.1} restitution={1.2} args={[s * 0.7, s * 0.16, s * 0.7]} />
          :
          <CylinderCollider friction={0.1} restitution={1.2} args={[s * 0.2, s, 32, 32]} />
        }
        <mesh position={[0, 0, 0]} geometry={new THREE.CylinderBufferGeometry(s, s, s * 0.4, sides)}>
          <meshBasicMaterial transparent opacity={0} depthTest={false} />
          <Edges color={col} threshold={3} />
        </mesh>
      </RigidBody>
      <Inner i={i} />
    </group>
  )
}
function Inner({ i }) {
  const ref = useRef();
  useFrame(() => {
    ref.current.rotation.y = lerp(ref.current.rotation.y, rots[i], 0.05)
  })
  return (
    <group ref={ref} rotation={[Math.PI * 0.5, rots[i], 0]}>
      <mesh position={[0, 0, 0]} rotation={[0, rots[i], 0]} ref={ref} geometry={new THREE.CircleBufferGeometry(s * 0.2, obstacleSides[i])}>
        <meshBasicMaterial transparent opacity={0} color={col} side={THREE.DoubleSide} depthTest={false}  />
        <Edges color={col} />
      </mesh>
    </group>
  )
}
console.log('%c🦉 @ramioso 2022-08-29 🦉', 'color: green');